<template>
  <!-- 包时段收费 -->
  <el-card
    style="width:815px"
  >
    <el-form
      ref="ruleTemp"
      label-width="120px"
    >
      <div class="clearfix inputParams-wrap">
        <el-form-item label="区间价格列表：">
        </el-form-item>
        <ul class="valuation-field-ul inputParams-ul clearfix">
          <li style="width:45%;float:left">区间段</li>
          <li style="width:25%;float:left">价格(元)</li>
          <li style="width:15%;float:left">预付成本(元)</li>
        </ul>
        <div
          class="clearfix"
          v-for="item in packetData.outputParamsPricings.section"
          :key="item.key"
        >
          <div class="valuation-field-wrap clearfix">
            <div
              class="valuation-field-list clearfix"
              style="float:left"
            >
              <div
                class="valuation-field-child clearfix"
                style="margin-bottom:10px"
              >
                <div style="width:350px;float:left;">
                  <el-date-picker
                    v-model="item.time"
                    type="daterange"
                    disabled
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                  ></el-date-picker>
                </div>
                <div style="width:150px;float:left;margin-left:20px;margin-right:10px">
                  <el-input
                    v-model="item.price"
                    disabled
                    placeholder="请输入价格"
                  ></el-input>
                </div>
                <div style="width:150px;float:left;margin-right:10px">
                  <el-input
                    disabled
                    v-model="item.expectPrice"
                    placeholder="请输入预付成本"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div></div> -->
      <el-form-item label="计费配置列表：">
      </el-form-item>
      <ul class="valuation-field-ul clearfix">
        <li>计价字段</li>
        <li>计价值</li>
        <li>是否计费</li>
      </ul>
      <div
        v-for="item in packetData.outputParamsPricings.outputParamsPricing"
        :key="item.key"
        class="clearfix"
      >
        <div class="valuation-field-wrap clearfix">
          <div
            class="valuation-field-list clearfix"
            style="width:60%;float:left"
          >
            <div
              v-for="(domain, index) in item.pricing"
              :key="index"
              class="valuation-field-child clearfix"
              style="margin-bottom:10px"
            >
              <div
                :prop="'pricing.' + index +'.key'"
                style="width:120px;float:left;margin-left:10px"
              >
                <el-select
                  v-model="domain.key"
                  disabled
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(param, parIndex) in interfaceParams"
                    :key="parIndex"
                    :label="param.paramName || param.fieldName"
                    :value="param.paramIdentify || param.fieldName"
                  ></el-option>
                </el-select>
              </div>
              <div
                :prop="'pricing.' + index +'.type'"
                style="width:120px;float:left;margin:0 15px 0 15px"
              >
                <el-select
                  v-model="domain.type"
                  disabled
                  placeholder=""
                >
                  <el-option
                    value="1"
                    label="等于"
                  ></el-option>
                  <el-option
                    value="2"
                    label="大于等于"
                  ></el-option>
                  <el-option
                    value="3"
                    label="小于等于"
                  ></el-option>
                  <el-option
                    value="4"
                    label="大于"
                  ></el-option>
                  <el-option
                    value="5"
                    label="小于"
                  ></el-option>
                  <el-option
                    value="6"
                    label="不等于"
                  ></el-option>
                </el-select>
              </div>
              <div
                :prop="'pricing.' + index +'.value'"
                style="width:120px;float:left"
              >
                <el-input
                  v-model="domain.value"
                  disabled
                  placeholder=""
                ></el-input>
              </div>
            </div>
          </div>
          <span
            class="valuation-field-btn"
            style="display:block;width:40%;float:left"
          >
            <div style="width:150px;float:right;margin-right:10px">
              <el-select
                v-model="charging"
                disabled
                placeholder=""
              >
                <el-option
                  :value="true"
                  label="是"
                ></el-option>
              </el-select>
            </div>
          </span>
        </div>
      </div>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['packetData', 'billFiledData'],
  name: 'valuationTemplate1',
  data () {
    return {
      ruleTemp: {
        inputParamsPricing: {},
        outputParamsPricings: {
          section: [
            {
              start: '2019-01-22',
              end: '2019-01-25',
              time: ['2019-01-22', '2019-01-25'], // 需要把start和end合并到time数组
              price: '10',
              expectPrice: '100'
            }
          ],
          outputParamsPricing: [
            {
              pricing: [
                {
                  type: '1',
                  key: 'returnCode',
                  value: '1',
                  returnCode: '1' // 这个字段需拆分成上面的key value
                },
                {
                  type: '5',
                  key: 'serviceId',
                  value: '4',
                  serviceId: '4' // 这个字段需拆分成上面的key value
                }
              ]
            }
          ]
        }
      },
      interfaceParams: [],
      charging: true
    }
  },
  created () {
    if (this.billFiledData) {
      this.interfaceParams = this.billFiledData
      this.inputParams = this.billFiledData
    } else {
      this.queryInterfaceParamInfoByAll()
    }
  },
  methods: {
    /* 查询计价字段列表 */
    queryInterfaceParamInfoByAll () {
      let _self = this
      /* 查询计价策略列表 */
      this.$axios
        .get(this.$API.valuation.queryInterfaceParamInfoByAll, {})
        .then(function (r) {
          // let data = r.data.resData.paramNameList
          _self.interfaceParams = r.data.resData.paramNameList
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /* 添加区间列表 */
    addSection () {
      this.ruleTemp.outputParamsPricings.section.push({
        time: [],
        price: '',
        expectPrice: ''
      })
    },
    /* 删除区间列表 */
    removeSection (item) {
      let index = this.ruleTemp.outputParamsPricings.section.indexOf(item)
      if (index !== -1) {
        this.ruleTemp.outputParamsPricings.section.splice(index, 1)
      }
    },
    /* 新增一组计费配置 */
    addGroup () {
      this.ruleTemp.outputParamsPricings.outputParamsPricing.push({
        pricing: [
          {
            type: '',
            key: '',
            value: ''
          }
        ]
      })
    },
    /* 删除组 */
    removeGroup (item, index) {
      let _index = this.ruleTemp.outputParamsPricings.outputParamsPricing.indexOf(item)
      if (_index !== -1) {
        this.ruleTemp.outputParamsPricings.outputParamsPricing.splice(_index, 1)
      }
    },
    /* 添加子字段 */
    addChild (item) {
      item.pricing.push({
        type: '',
        key: '',
        value: ''
      })
    },
    /* 删除子字段 */
    removeChild (item, index) {
      if (index !== -1) {
        item.pricing.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../assets/sass/base.scss";
.clearfix {
  @include clearfix;
}
.text-wrap {
  overflow: hidden;
  line-height: 30px;
  width: 100%;
}

.valuation-field-ul {
  li {
    float: left;
    width: 32%;
    text-align: center;
    line-height: 50px;
  }
}
.valuation-field-wrap {
  position: relative;
  margin-bottom: 20px;
  border-bottom: #ddd solid 1px;
  .valuation-field-list {
    .valuation-field-child {
      position: relative;
      height: 45px;
      &:before {
        content: "";
        position: absolute;
        top: 20px;
        right: -40px;
        width: 45px;
        height: 1px;
        background: #409eff;
      }
      &:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -40px;
        width: 1px;
        height: 55px;
        background: #409eff;
      }
    }
  }
  .valuation-field-btn {
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -30px;
    &:after {
      content: "";
      position: absolute;
      top: 22px;
      left: 40px;
      width: 50px;
      height: 1px;
      background: #409eff;
    }
  }
}

.valuation-field-list .valuation-field-child:last-child::after {
  content: "";
  position: absolute;
  top: 20px;
  right: 20px;
  width: 1px;
  height: 55px;
  background: rgba($color: #409eff, $alpha: 0);
}

.inputParams-wrap {
  margin-bottom: 20px;
  .valuation-field-wrap {
    .valuation-field-list {
      .valuation-field-child {
        &:before {
          background: none !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customerManagement/packetRule.vue